import React from 'react'
import { Box, CardMedia, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { CartLineItem } from '../../models'
import { currencyFormatter, getImageUrlBySize } from '../../utils'
import { ShopImageThumnbailSizes } from '../../types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface ConfirmCheckoutConfigureSystemSubProductProps {
  product: CartLineItem
  configuratorQuantity: number
}

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
  },
  productImage: {
    width: 75,
    height: 75,
    objectFit: 'contain',
    backgroundColor: theme.palette.shades.shade03,
    marginRight: theme.spacing(2),
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  imageColumn: {
    display: 'flex',
    alignItems: 'center',
    width: '70%',
  },
  quantityColumn: {
    width: '15%',
    textAlign: 'left',
  },
  priceColumn: {
    width: '15%',
    textAlign: 'right',
  },
  productLabel: {
    whiteSpace: 'break-spaces',
  },
}))

const QUANTITY_SYMBOL = 'x'

/*
 * This component is used to show selected items of a configured system in confirm checkout.
 */
const ConfirmCheckoutConfigureSystemSubProduct: React.FC<ConfirmCheckoutConfigureSystemSubProductProps> = ({ product, configuratorQuantity }) => {
  const productImageUrl = getImageUrlBySize(product.cover?.thumbnails, ShopImageThumnbailSizes.Small)
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const quantity = product.quantity / configuratorQuantity
  const quantityText = `${quantity}${QUANTITY_SYMBOL}`
  const pricePerProduct = currencyFormatter(product.price.unitPrice)

  return (
    <Box className={classes.container}>
      <Box className={classes.imageColumn}>
        <CardMedia className={classes.productImage} component="img" image={productImageUrl} />
        <Typography className={classes.productLabel}>{product.label}</Typography>
      </Box>

      <Box className={`${classes.column} ${classes.quantityColumn}`}>
        <Typography variant="subtitle2"> {t('shop.confirm-checkout.sub-product-quantity')}</Typography>
        <Typography>{quantityText}</Typography>
      </Box>

      <Box className={`${classes.column} ${classes.priceColumn}`}>
        <Typography variant="subtitle2"> {t('shop.confirm-checkout.sub-product-price')}</Typography>
        <Typography>{pricePerProduct}</Typography>
      </Box>
    </Box>
  )
}

export default ConfirmCheckoutConfigureSystemSubProduct
